import * as React from 'react';
import Stores from '@ui/scenes/Stores';

const StoresPage = () => <Stores />;

export default StoresPage;



// WEBPACK FOOTER //
// ./src/pages/Stores/Stores.tsx